import styled from 'styled-components'

import List from '../../atoms/List'

import State from './State'

const CustomList = styled(List)`
  ${props =>
    props.columns
      ? `
    display: block !important;
    column-width: auto;
    column-count: 1;

    @media (min-width: 768px) {
      column-count: 2;
    }

    @media (min-width: 992px) {
      column-count: 3;
    }
  `
      : ''}

  ${State} {
    break-inside: ${props => (props.columns ? 'avoid' : '')};
  }
`

export default CustomList
